import { useSearchParams, usePathname } from "next/navigation";
import { TabContainer } from "nvs-design-system/dist/TabContainer";
import { TabLink } from "@/src/components/buttons/components/TabLink";
import { renderTab, TABS } from "./helpers";

type Props = {
  productName: string;
  collectionName: string;
  tokenId?: string;
};

const ProductTabs: React.FC<Props> = ({
  productName,
  collectionName,
  tokenId,
}) => {
  const searchParams = useSearchParams();
  const tab = searchParams?.get("tab") ?? TABS.STORY;
  const pathname = usePathname();
  const pdpTabs = [TABS.STORY, TABS.UTILITY];
  const tlpTabs = [TABS.STORY, TABS.DETAILS, TABS.UTILITY];
  const tabs = tokenId ? tlpTabs : pdpTabs;

  return (
    <div className="dark bg-gray-950 dark:text-white h-[inherit] relative">
      <div className="flex flex-col h-full gap-6 justify-between desktop:px-[22px]">
        <TabContainer className="my-6 snap-x snap-mandatory w-fit">
          {tabs.map((currTab, i) => (
            <TabLink
              key={currTab}
              href={`${pathname}?tab=${currTab}`}
              shallow // change the URL without running data fetching methods again
              scroll={false} // We need this so the page doesn't scroll to top on tab clicks
              isSelected={tab === currTab}
              size={"sm"}
              className={i === 0 ? "snap-start" : ""}
              data-testid={currTab}
            >
              {currTab}
            </TabLink>
          ))}
        </TabContainer>

        <div className="pb-12 dark:text-white">
          {tab &&
            renderTab(
              tab,
              productName as string,
              collectionName as string,
              tokenId as string,
            )}
        </div>
      </div>
    </div>
  );
};

export default ProductTabs;
